export { default } from "./PowerWordsQuestion";
